import React, { useState } from 'react'

export default function LogoCard(props) {
  let [project] = useState(props.project)
  return (
    <React.Fragment>
      <div key={project.id} className="card">
        <div>
          <div className="img-con">
            <img className="image" src={project.attributes.image.data.attributes.url} alt={project.attributes.title || ""} />
          </div>
          <p className="content">{project.attributes.description}</p>
        </div>
      </div>
    </React.Fragment>

  )
}
